
export const enum ProductTypeEnum {
    Unknown = 0,
    CDAudio, /*DDP*/
    SDAudio,
    HDAudio,
    SDHDAudio,
    DolbyAtmos,
    Vinyl,
    Cassette,
    DVD,
    BluRay
};
